import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, resolveComponent as _resolveComponent, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-126043d3"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "card" }
const _hoisted_2 = { class: "card-header" }
const _hoisted_3 = {
  key: 0,
  class: "card-action float-end"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  class: "btn",
  "data-bs-toggle": "dropdown",
  "aria-expanded": "false"
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "fas fa-cog me-2" }),
  /*#__PURE__*/_createTextVNode("จัดการข้อมูล ")
], -1))
const _hoisted_5 = { class: "dropdown-menu" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fas fa-comment me-2" }, null, -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", null, [
  /*#__PURE__*/_createElementVNode("hr", { class: "dropdown-divider" })
], -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fas fa-ban me-2" }, null, -1))
const _hoisted_10 = { key: 0 }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fas fa-edit me-2" }, null, -1))
const _hoisted_12 = { key: 1 }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fas fa-paperclip me-2" }, null, -1))
const _hoisted_14 = { key: 2 }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fas fa-image me-2" }, null, -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", { class: "card-title" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "far fa-file-alt me-2" }),
  /*#__PURE__*/_createTextVNode("ข้อมูลรายละเอียดโครงการ")
], -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", { class: "card-subtitle text-muted" }, "แสดงข้อมูลรายละเอียดผลการดำเนินการโครงการ", -1))
const _hoisted_18 = { class: "card-body" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ProjectResultComponent = _resolveComponent("ProjectResultComponent")!
  const _component_ProjectDetailComponent = _resolveComponent("ProjectDetailComponent")!
  const _component_ProjectProcureComponent = _resolveComponent("ProjectProcureComponent")!
  const _component_ProjectProgressComponent = _resolveComponent("ProjectProgressComponent")!
  const _component_ProjectFinishComponent = _resolveComponent("ProjectFinishComponent")!
  const _component_ProjectEnjoinFormComponent = _resolveComponent("ProjectEnjoinFormComponent")!
  const _component_ProjectCancelFormComponent = _resolveComponent("ProjectCancelFormComponent")!
  const _component_ProjectCancelAttachmentModalComponent = _resolveComponent("ProjectCancelAttachmentModalComponent")!
  const _component_ProjectCancelAttachmentFormComponent = _resolveComponent("ProjectCancelAttachmentFormComponent")!
  const _component_ProjectCancelImageModelComponent = _resolveComponent("ProjectCancelImageModelComponent")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        (_ctx.isOrs || ((_ctx.isMinister || _ctx.isProvince) && !_ctx.project?.isFinished))
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _hoisted_4,
              _createElementVNode("ul", _hoisted_5, [
                ((_ctx.isOrs || _ctx.isMinister) && !_ctx.project?.isCanceled)
                  ? (_openBlock(), _createElementBlock("li", _hoisted_6, [
                      _createElementVNode("button", {
                        class: "dropdown-item",
                        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.enjoinClick && _ctx.enjoinClick(...args)))
                      }, [
                        _hoisted_7,
                        _createTextVNode("สั่งการ/เร่งรัดโครงการ ")
                      ])
                    ]))
                  : _createCommentVNode("", true),
                ((_ctx.isOrs || _ctx.isProvince) && !_ctx.project?.isCanceled)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _hoisted_8,
                      _createElementVNode("li", null, [
                        _createElementVNode("button", {
                          class: "dropdown-item",
                          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.cancelClick && _ctx.cancelClick(...args)))
                        }, [
                          _hoisted_9,
                          _createTextVNode("ยกเลิกโครงการ ")
                        ])
                      ])
                    ], 64))
                  : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                      (_ctx.isOrs || _ctx.isProvince)
                        ? (_openBlock(), _createElementBlock("li", _hoisted_10, [
                            _createElementVNode("button", {
                              class: "dropdown-item",
                              onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.editCancelClick && _ctx.editCancelClick(...args)))
                            }, [
                              _hoisted_11,
                              _createTextVNode("แก้ไขข้อมูลการยกเลิก ")
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.isOrs || _ctx.isProvince)
                        ? (_openBlock(), _createElementBlock("li", _hoisted_12, [
                            _createElementVNode("button", {
                              class: "dropdown-item",
                              onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.attachmentClick && _ctx.attachmentClick(...args)))
                            }, [
                              _hoisted_13,
                              _createTextVNode("จัดการเอกสารแนบ ")
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.isOrs || _ctx.isProvince)
                        ? (_openBlock(), _createElementBlock("li", _hoisted_14, [
                            _createElementVNode("button", {
                              class: "dropdown-item",
                              onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.imageClick && _ctx.imageClick(...args)))
                            }, [
                              _hoisted_15,
                              _createTextVNode("จัดการรูปภาพประกอบ ")
                            ])
                          ]))
                        : _createCommentVNode("", true)
                    ], 64))
              ])
            ]))
          : _createCommentVNode("", true),
        _hoisted_16,
        _hoisted_17
      ]),
      _createElementVNode("div", _hoisted_18, [
        _createVNode(_component_ProjectResultComponent, {
          "project-id": _ctx.project?.id
        }, null, 8, ["project-id"])
      ])
    ]),
    (_ctx.project)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _createVNode(_component_ProjectDetailComponent, {
            "project-id": _ctx.project?.id,
            onRefresh: _ctx.refresh
          }, null, 8, ["project-id", "onRefresh"]),
          _createVNode(_component_ProjectProcureComponent, {
            "project-id": _ctx.project?.id,
            onRefresh: _ctx.refresh
          }, null, 8, ["project-id", "onRefresh"]),
          _createVNode(_component_ProjectProgressComponent, {
            "project-id": _ctx.project?.id,
            onRefresh: _ctx.refresh
          }, null, 8, ["project-id", "onRefresh"]),
          _createVNode(_component_ProjectFinishComponent, {
            "project-id": _ctx.project?.id,
            onRefresh: _ctx.refresh
          }, null, 8, ["project-id", "onRefresh"])
        ], 64))
      : _createCommentVNode("", true),
    (_ctx.project)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          _createVNode(_component_ProjectEnjoinFormComponent, {
            ref: "projectEnjoinForm",
            "project-id": _ctx.project?.id
          }, null, 8, ["project-id"]),
          _createVNode(_component_ProjectCancelFormComponent, {
            ref: "projectCancelForm",
            "project-id": _ctx.project?.id,
            onRefresh: _ctx.refresh
          }, null, 8, ["project-id", "onRefresh"]),
          _createVNode(_component_ProjectCancelAttachmentModalComponent, {
            ref: "projectCancelAttachmentModel",
            "project-id": _ctx.project?.id,
            onUpload: _ctx.uploadClick
          }, null, 8, ["project-id", "onUpload"]),
          _createVNode(_component_ProjectCancelAttachmentFormComponent, {
            ref: "projectCancelAttachmentForm",
            "project-id": _ctx.project?.id,
            onHidden: _ctx.uploadClose
          }, null, 8, ["project-id", "onHidden"]),
          _createVNode(_component_ProjectCancelImageModelComponent, {
            ref: "projectCancelImageModal",
            "project-id": _ctx.project?.id
          }, null, 8, ["project-id"])
        ], 64))
      : _createCommentVNode("", true)
  ], 64))
}